import React from 'react'

export default function Forward() {
    return (
        <svg viewBox="0 0 24 24" style={{width: '22px',
                                        height: '22px'}}>
            <path fill="currentColor" d="M7.96 21.15l-.65-.76 9.555-8.16L7.31 4.07l.65-.76 10.445 8.92"></path>
        </svg>
    )
}
